import { createSodexArrayEnvelopeSchema } from '../sodexEnvelopeSchema'
import { userTradeSchema } from '../userTradeSchema'

export const responseSchema = createSodexArrayEnvelopeSchema(userTradeSchema)
